import { FC } from 'react';
import { SecondaryTextTypography } from '../../../../../App.styles';
import { Typography } from '../../../../../stories/atoms';
import { ColumnFlexContainer } from '../../../../../stories/atoms/containerV2/ContainerV2';
import { ChipsWrapper, StyledChipWrapper, StyledIndexTypography } from './MobileChipLayout.styles';

export type LayoutType = 'grid' | 'row';
export type ChipStatusType = 'default' | 'positive' | 'negative';

type MobileChipProps = {
  chipValue: string;
  chipText: string;
  chipStatus: ChipStatusType;
};

export type LayoutDetails = {
  label: string;
  value: string;
  status: ChipStatusType;
};

type MobileChipLayoutProps = {
  layout: LayoutType;
  layoutData: LayoutDetails[];
  layoutTitle?: string;
  gridColumns?: number;
};

export const MobileChip: FC<MobileChipProps> = ({ chipValue, chipText, chipStatus }) => {
  return (
    <StyledChipWrapper padding={[2]} gap={[1]} data-testid="mobile-chip-wrapper">
      <StyledIndexTypography type="body3" status={chipStatus}>
        {chipValue}
      </StyledIndexTypography>
      <SecondaryTextTypography type="caption">{chipText}</SecondaryTextTypography>
    </StyledChipWrapper>
  );
};

export const MobileChipLayout: FC<MobileChipLayoutProps> = ({
  layout,
  layoutData,
  layoutTitle,
  gridColumns = 3,
}) => {
  return (
    <ColumnFlexContainer gap={[2]}>
      {layoutTitle && <Typography>{layoutTitle}</Typography>}
      <ChipsWrapper layout={layout} gridColumns={gridColumns}>
        {layoutData.map((dataItem, index) => (
          <MobileChip
            key={index}
            chipValue={dataItem.value}
            chipText={dataItem.label}
            chipStatus={dataItem.status}
          />
        ))}
      </ChipsWrapper>
    </ColumnFlexContainer>
  );
};
